import {
  FETCH_REGIONAL_INCENTIVES_SUCCESS,
  INIT_MAIN,
  START_OVER_SUCCESS,
  TOGGLE_OPTION_CONFLICT_RESOLVE,
  TOGGLE_OPTION_SUCCESS,
  UPDATE_CONFIG_SUCCESS,
} from '../actionTypes';

export default function incentives(state, action) {
  const payload = action.payload;

  switch (action.type) {
    case INIT_MAIN:
    case TOGGLE_OPTION_SUCCESS:
    case TOGGLE_OPTION_CONFLICT_RESOLVE:
    case UPDATE_CONFIG_SUCCESS:
    case START_OVER_SUCCESS:
      return payload.incentives;
    case FETCH_REGIONAL_INCENTIVES_SUCCESS:
      return payload;
    default:
      return state || {};
  }
}
